export function buildTraitsById<T extends { id: unknown }>(
  traitDefinitions: T[] | undefined,
  journeyTraits?: readonly T[],
): Map<string, T> | undefined {
  if (!traitDefinitions) return undefined;
  const map = new Map<string, T>(
    traitDefinitions.map((trait) => [String(trait.id), trait]),
  );
  for (const trait of journeyTraits ?? []) {
    map.set(String(trait.id), trait);
  }
  return map;
}
